import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
// import "../assets/style.css";
import "../assets/team.css";
import Git from "./Git";
import LatestNews from "./LatestNews";

interface TeamMember {
  id: number;
  name: string;
  role: string;
  role2?: string;
  whatsapp?: string;
  image?: string;
  delay?: string;
  section: "team_p1" | "team_p2";
  sort_order: number;
  status: "active" | "inactive";
}

const API_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";
const IMAGE_URL =
  import.meta.env.VITE_LYRAZONE_IMAGE_URL || "http://localhost:5000";

const Team: React.FC = () => {
  const [teamData, setTeamData] = useState<TeamMember[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/admin/team/public`);
      setTeamData(Array.isArray(response.data?.data) ? response.data.data : []);
    } catch (error) {
      console.error("Failed to fetch team members:", error);
      setTeamData([]);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (fileName?: string) => {
    if (!fileName) return "";
    if (fileName.startsWith("http")) return fileName;
    return `${IMAGE_URL}/uploads/team/${fileName}`;
  };

  const teamMembers = useMemo(
    () =>
      teamData
        .filter((member) => member.section === "team_p1")
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)),
    [teamData],
  );

  const otherMembers = useMemo(
    () =>
      teamData
        .filter((member) => member.section === "team_p2")
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)),
    [teamData],
  );

  return (
    <>
      <div id="home-p" className="home-p pages-head8 text-center">
        <div className="container">
          {/* <h1 className="wow fadeInUp" data-wow-delay="0.1s">
            Lyra Zone is fully equipped with ICT tools
          </h1>
          <p>Our Services</p> */}
        </div>
      </div>
      {/* Team-P1 Section */}
      <section id="team-p1" className="team-p1">
        <div className="container">
          <div className="row">
            {loading ? (
              <div className="col-md-12 text-center">
                <p>Loading team members...</p>
              </div>
            ) : teamMembers.length > 0 ? (
              teamMembers.map((member) => (
                <div className="col-md-6" key={member.id}>
                  <div
                    className="team-p1-cont wow fadeInUp"
                    data-wow-delay={member.delay || "0.2s"}
                  >
                    {member.image && (
                      <img
                        src={getImageUrl(member.image)}
                        className="img-fluid"
                        alt={member.name}
                      />
                    )}

                    <h5>{member.name}</h5>
                    <h6>{member.role}</h6>
                    {member.role2 ? <h6>{member.role2}</h6> : null}

                    <ul
                      className="list-inline social-icon-f top-data"
                      style={{ position: "relative" }}
                    >
                      {member.whatsapp && (
                        <li>
                          <a
                            href={`https://wa.me/${member.whatsapp.replace(/\D/g, "")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa top-social fa-whatsapp"></i>
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          href="https://www.facebook.com/people/Lyra-Zone-Solutions/61553204526797/?mibextid=kFxxJD"
                          target="_empty"
                        >
                          <i className="fa top-social fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/lyra-zone-solutions/posts/?feedView=all"
                          target="_empty"
                        >
                          <i className="fa top-social fa-linkedin"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/channel/UC4HuaQMMFnFcLRB3IirK-Sg"
                          target="_empty"
                        >
                          <i className="fa top-social fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12 text-center">
                <p>No team members available right now.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Team-P2 Section */}
      <section id="comp-offer" className="team-p2">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-6 desc-comp-offer">
              <h2>Team Member</h2>
              <div className="heading-border-light"></div>
            </div>
          </div>

          <div className="row">
            {loading ? (
              <div className="col-md-12 text-center">
                <p>Loading team members...</p>
              </div>
            ) : otherMembers.length > 0 ? (
              otherMembers.map((member) => (
                <div className="col-md-4 col-sm-6" key={member.id}>
                  <div
                    className="team-p2-cont wow fadeInUp"
                    style={{ marginTop: "20px" }}
                    data-wow-delay={member.delay || "0.2s"}
                  >
                    {member.image && (
                      <img
                        src={getImageUrl(member.image)}
                        className="img-team-member"
                        alt={member.name}
                      />
                    )}
                    <h5>{member.name}</h5>
                    <h6>{member.role}</h6>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12 text-center">
                <p>No additional team members available right now.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Git />
      <LatestNews />
    </>
  );
};

export default Team;
